import {query} from '@/common/http'
export function pay(param, func){
  // if (typeof window.WeixinJSBridge != "undefined"){
    query('/wx/order/'+new Date().getTime()+'/billing',param, function(res){
      if(res.code === 1) {
        var data = res['data']
        onBridgeReady(data,func)
      } else if(res.code === 2){
        func(res.code)
      } else {
        func(-1, "error")
      }
    })
}
export function onBridgeReady(param,func){
  if (typeof window.WeixinJSBridge != "undefined"){
    window.WeixinJSBridge.invoke(
      'getBrandWCPayRequest',{
          debug:true,
          "appId": param.appId,
          "timeStamp": param.timeStamp,
          "nonceStr": param.nonceStr,
          "package": param.package,
          "signType": param.signType,
          "paySign": param.paySign,
      },
      function(res) {
        if(res.err_msg == "get_brand_wcpay_request:ok" ){
          // alert("支付成功")
          if(func)(
            func(1)
          )
        }else{
          // alert("支付失败,请跳转页面"+res.err_msg);
          func(-1,res.err_msg)
        }
      }
    )
  } else {
    alert("请在微信中打开!!")
    func(-1,"请在微信中打开!")
  }
}
